export default __webpack_public_path__ + "0c8111df20c3d94779f8192668623f2d.jpg";